<script setup>
import MemQueryHistory from '@/components/admin/config/MemQueryHistory.vue'
import Logs from '@/components/admin/config/Logs.vue'
import ManAlarm from '@/components/admin/config/ManAlarm.vue'
import ManBgMap from '@/components/admin/config/ManBgMap.vue'
import ManEpsg from '@/components/admin/config/ManEpsg.vue'
import ServerMon from '@/components/admin/config/ServerMon.vue'
import AdmLayout from '@/pages/layout/AdmLayout.vue'
import ManCompanyInfo from '@/components/admin/config/ManCompanyInfo.vue'
import { ref } from 'vue'
import SetMapInitPos from '@/components/admin/config/SetMapInitPos.vue'
import ManEtc from '@/components/admin/config/ManEtc.vue'
const submenus=ref(['mapsettings','setcoordinatesystem','notificationsettings','servermonitoring','viewlogs','memberinformationaccesshistory','man_com_info','set_map_pos','etc_config'])
const manBgMapRef=ref(null)
</script>
<template>
  <AdmLayout menutk="sysconf" :submenus="submenus" @tabChanged="tab=>{
    if(tab=='mapsettings'&&manBgMapRef)manBgMapRef[0].init()
  }">
    <v-tabs-window-item v-for="sm in submenus" :value="sm" :key="sm">
      <ManBgMap v-if="sm=='mapsettings'" ref="manBgMapRef"/>
      <ManEpsg v-if="sm=='setcoordinatesystem'"/>
      <ManAlarm v-if="sm=='notificationsettings'"/>
      <ServerMon v-if="sm=='servermonitoring'"/>
      <Logs v-if="sm=='viewlogs'"/>
      <MemQueryHistory v-if="sm=='memberinformationaccesshistory'"/>
      <ManCompanyInfo v-if="sm=='man_com_info'"/>
      <SetMapInitPos v-if="sm=='set_map_pos'"/>
      <ManEtc v-if="sm=='etc_config'"/>
    </v-tabs-window-item>
  </AdmLayout>
</template>
